import { groupDelayRenderer } from './charts/group-delay.js';
import { phaseRenderer } from './charts/phase.js';
import { rectangularRenderer } from './charts/rectangular.js';
import { smithRenderer } from './charts/smith.js';
import { vswrRenderer } from './charts/vswr.js';
export class ChartRegistry {
    byKind = new Map();
    register(renderer) {
        this.byKind.set(renderer.kind, renderer);
    }
    get(kind) {
        return this.byKind.get(kind);
    }
    list() {
        return Object.freeze([...this.byKind.values()]);
    }
}
/**
 * Creates a registry with all 5 built-in renderers registered.
 */
export function createDefaultRegistry() {
    const reg = new ChartRegistry();
    reg.register(rectangularRenderer);
    reg.register(smithRenderer);
    reg.register(vswrRenderer);
    reg.register(phaseRenderer);
    reg.register(groupDelayRenderer);
    return reg;
}
//# sourceMappingURL=registry.js.map